(function () {
  if (!document.body.classList.contains('template-index')) return;

  const sections = document.querySelectorAll('main .shopify-section, #MainContent .shopify-section');
  if (!sections.length) return;

  sections.forEach((section) => {
    section.setAttribute('data-scroll-reveal', '');
  });

  if (!('IntersectionObserver' in window)) {
    sections.forEach((section) => { section.classList.add('is-visible'); });
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });

  sections.forEach((section) => { observer.observe(section); });

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.shopify-section') || e.target;
    if (section && section.classList.contains('shopify-section')) {
      section.setAttribute('data-scroll-reveal', '');
      section.classList.add('is-visible');
    }
  });
})();
